import React from 'react';
import { Router, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { history } from './utils/variables';

//components
import Header from './components/master/Header';
import Footer from './components/master/Footer';

//pages
import Home from './pages/master/Home';
import About from './pages/master/About';
import Login from './pages/master/Login';
import Waiting from './pages/client/Waiting';
import LossesAccident from './pages/client/LossesAccident';
import Complete from './pages/client/Complete';
import Success from './pages/master/Success';
import Tutorial from './pages/master/Tutorial';
import ReportList from './pages/master/ReportList';
import ReportSingle from './pages/master/ReportSingle';
import EditProfile from './pages/master/EditProfile';
import Register from './pages/register/Register';
import RegisterList from './pages/register/RegisterList';
import RegisterSingle from './pages/register/RegisterSingle';
import RegisterImages from './pages/register/RegisterImages';
import RegisterPricing from './pages/register/RegisterPricing';
import ExpertWaiting from './pages/expert/ExpertWaiting';
import ExpertMap from './pages/expert/ExpertMap';
import CulpritDetail from './pages/expert/CulpritDetail';
import LossesDetail from './pages/expert/LossesDetail';
import ExpertImages from './pages/expert/ExpertImages';
import FinalPricing from './pages/expert/FinalPricing';
import Review from './pages/expert/Review';
import EditReport from './pages/expert/EditReport';
import Rules from './pages/master/Rules';
import Wallet from './pages/expert/Wallet';
import Development from './pages/dev/Development';
import ThirdPartyLogin from './pages/client/ThirdPartyLogin';
import UserCarInfo from './pages/client/UserCarInfo';
import Error from './pages/master/Error';
import Receipt from './components/pages/receipt';
import Payment from './components/master/Payment';
import { useSelector } from 'react-redux';

export default function App() {
    const {language} = useSelector(store=> store)
    return (
        <div className={`App ${(language.lang === 'en' || language.lang === 'ru')? 'lr': ''}`}> 
            <ToastContainer />
            <Router history={history}>
                <div className='container'>
                    <Header />
                    <Route path='/' component={Home} exact />
                    <Route path='/tutorial' component={Tutorial} />
                    <Route path='/about' component={About} />
                    <Route path='/login' component={Login} />
                    <Route path='/waiting' component={Waiting} />
                    <Route path='/losses-accident' component={LossesAccident} />
                    <Route path='/complete' component={Complete} />
                    <Route path='/success/:id' component={Success} />
                    <Route path='/report-list' component={ReportList} />
                    <Route path='/report-single/:id?' component={ReportSingle} />
                    <Route path='/edit-profile' component={EditProfile} />
                    <Route path='/register' component={Register} />
                    <Route path='/register-list' component={RegisterList} />
                    <Route path='/register-single' component={RegisterSingle} />
                    <Route path='/register-images' component={RegisterImages} />
                    <Route path='/register-pricing' component={RegisterPricing} />
                    <Route path='/expert-waiting' component={ExpertWaiting} />
                    <Route path='/expert-map' component={ExpertMap} />
                    <Route path='/culprit-detail' component={CulpritDetail} />
                    <Route path='/losses-detail' component={LossesDetail} />
                    <Route path='/expert-images' component={ExpertImages} />
                    <Route path='/final-pricing' component={FinalPricing} />
                    <Route path='/review' component={Review} />
                    <Route path='/edit-report/:type?' component={EditReport} />
                    <Route path='/rules' component={Rules} />
                    <Route path='/wallet' component={Wallet} />
                    <Route path='/development' component={Development} />
                    <Route path='/third-party-login' component={ThirdPartyLogin} />
                    <Route path='/user-car-info' component={UserCarInfo} />
                    <Route path='/error' component={Error} />
                    <Route path='/receipt' component={Receipt}/>
                    <Route path='/payment' component={Payment}/>
                    <Footer />
                </div>
            </Router>
        </div>
    );

}
